export const storeInwards = (state = [], action) => {
  if (action.type === 'FETCH_STORE_INWARDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_STORE_INWARDS') {
    return [];
  }
  return state;
};

export const storeInward = (state = {}, action) => {
  if (action.type === 'FETCH_STORE_INWARD') {
    return action.payload;
  }
  if (action.type === 'CLEAR_STORE_INWARD') {
    return {};
  }
  return state;
};

export const storeInwardsOfRpo = (state = [], action) => {
  if (action.type === 'FETCH_STORE_INWARDS_OF_RPO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_STORE_INWARDS_OF_RPO') {
    return [];
  }
  return state;
};

export const inwardItemsForQualityCheckInputTable = (
  state = {
    fabrics: { productIndexes: {}, productNames: [], fabrics: [] },
    accessories: { productIndexes: {}, productNames: [], accessories: {} },
    items: { names: [], shades: {}, sizes: {}, units: {} },
    styles: { products: [], styles: {} },
    isProductColumn: false,
  },
  action
) => {
  if (action.type === 'FETCH_STORE_INWARD_FOR_QUALITY_CHECK_INPUT_TABLE') {
    return action.payload;
  }
  if (action.type === 'CLEAR_STORE_INWARD_FOR_QUALITY_CHECK_INPUT_TABLE') {
    return {
      fabrics: { productIndexes: {}, productNames: [], fabrics: [] },
      accessories: { productIndexes: {}, productNames: [], accessories: {} },
      items: { names: [], shades: {}, sizes: {}, units: {} },
      styles: { products: [], styles: {} },
      isProductColumn: false,
    };
  }
  return state;
};

export const mrr = (state = { items: [], summary: [] }, action) => {
  if (action.type === 'FETCH_MRR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_MRR') {
    return { items: [], summary: [] };
  }
  return state;
};

export const customerIdsForMrr = (state = [], action) => {
  if (action.type === 'FETCH_CUSTOMER_IDS_FOR_MRR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_CUSTOMER_IDS_FOR_MRR') {
    return [];
  }
  return state;
};

export const jobchartIdsForMrr = (state = [], action) => {
  if (action.type === 'FETCH_JOBCHART_IDS_FOR_MRR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_JOBCHART_IDS_FOR_MRR') {
    return [];
  }
  return state;
};

export const processesForMrr = (state = [], action) => {
  if (action.type === 'FETCH_PROCESSES_FOR_MRR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_PROCESSES_FOR_MRR') {
    return [];
  }
  return state;
};

export const vendorIdsForMrr = (state = [], action) => {
  if (action.type === 'FETCH_VENDOR_IDS_FOR_MRR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VENDOR_IDS_FOR_MRR') {
    return [];
  }
  return state;
};

export const rpoIdsForMrr = (state = [], action) => {
  if (action.type === 'FETCH_RPO_IDS_FOR_MRR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_IDS_FOR_MRR') {
    return [];
  }
  return state;
};
